angular.module('bmsApp.settings').factory('MMCleaningInstructionSvc', function ($http, $log, $window, $q, CRUDSvc, CLEANING_INSTRUCTION_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(CLEANING_INSTRUCTION_API.INDEX, params);
		},
		options: function (params) {
			return CRUDSvc.get(CLEANING_INSTRUCTION_API.OPTIONS, params);
		}
	}

}).constant('CLEANING_INSTRUCTION_API', {
	INDEX: 'api/merrymaids/cleaning-instruction/index',
	OPTIONS: 'api/merrymaids/cleaning-instruction/options'
});
